import { WebhookAddress, IWebhookService, WebhookFormat } from '@truckdown/systems'
import { ApiKeyModel, ApiKeyStatus, IApiKeyService, IApiTokenService } from '@truckdown/accounts';
import context from '@truckdown/components-systems';
import { defineComponent, ref, Ref, watch, computed, onMounted } from 'vue';
import { showMessage, isSystemAdmin } from "../Utilities/Utilities";
import refreshApiKey from "./RefreshApiKey/RefreshApiKey.vue";
import removeApiKey from "./RemoveApiKey/RemoveApiKey.vue";
import editApiKey from "./EditApiKey/EditApiKey.vue";
import addApiKey from "./AddApiKey/AddApiKey.vue";
import addWebhook from "./AddWebhook/AddWebhook.vue";
import verifyWebhook from "./VerifyWebhook/VerifyWebhook.vue";

interface IData {
    isLoading: Ref<boolean>,

    apiKeysData: Ref<ApiKeyModel[]>,
    webhooksData: Ref<WebhookAddress[]>,

    accountId: Ref<string>,
    showEditApiKeyModal: Ref<boolean>,
    editApiKey: Ref<ApiKeyModel | undefined>,
    statusUpdateMessage: Ref<string>,
    isSystemAdmin: Ref<boolean>
    showApiKeys: Ref<IShowApiKey[]>,
    showRefreshApiKeyModal: Ref<boolean>,
    showRemoveApiKeyModal: Ref<boolean>,
    refreshApiKey: Ref<ApiKeyModel | undefined>,
    removeApiKey: Ref<ApiKeyModel | undefined>,
    showAddApiKeyModal: Ref<boolean>,

    showAddWebhookModal: Ref<boolean>,
    showVerifyWebhookModal: Ref<WebhookAddress | undefined>,

    verificationToken1: Ref<string | undefined>,
    verificationToken2: Ref<string | undefined>,

    showRemoveWebhookModal: Ref<WebhookAddress | undefined>,

    showConfirmRotateModal: Ref<boolean>,

    apiTokens: Ref<string[]>,
    shownToken: Ref<string | undefined>,
    showRemoveApiTokenModal: Ref<string | undefined>
}

interface IShowApiKey {
    apiKey: string,
    apiSecret: string,
    showSecret: boolean
}

const closeModals = function (data: IData) {
    data.showEditApiKeyModal.value = false;
    data.showRefreshApiKeyModal.value = false;
    data.showRemoveApiKeyModal.value = false;
    data.showAddApiKeyModal.value = false;
}

const getInitialData = function (props: any) {
    return {
        isLoading: ref<boolean>(false),
        apiKeysData: ref<ApiKeyModel[]>(props.apiKeys),
        webhooksData: ref<WebhookAddress[]>(props.webhooks),

        accountId: ref<string>(props.accountId),
        showEditApiKeyModal: ref<boolean>(false),
        editApiKey: ref<ApiKeyModel | undefined>(undefined),
        isSystemAdmin: ref<boolean>(isSystemAdmin()),
        showApiKeys: ref<IShowApiKey[]>(getShowApiKeys(props.apiKeys)),
        showRefreshApiKeyModal: ref<boolean>(false),
        showRemoveApiKeyModal: ref<boolean>(false),
        refreshApiKey: ref<ApiKeyModel | undefined>(undefined),
        removeApiKey: ref<ApiKeyModel | undefined>(undefined),
        showAddApiKeyModal: ref<boolean>(false),

        showAddWebhookModal: ref<boolean>(false),
        showVerifyWebhookModal: ref<WebhookAddress | undefined>(),

        verificationToken1: ref<string | undefined>(),
        verificationToken2: ref<string | undefined>(),

        showRemoveWebhookModal: ref<WebhookAddress | undefined>(),

        showConfirmRotateModal: ref<boolean>(false),

        apiTokens: ref<string[]>([]),
        shownToken: ref<string | undefined>(),
        showRemoveApiTokenModal: ref<string | undefined>()
    } as IData;
}

const getShowApiKeys = function (apiKeys: ApiKeyModel[]): IShowApiKey[] {
    let showApiKeys = [];
    for (var i = 0; i < apiKeys.length; i++) {
        showApiKeys.push({
            apiKey: apiKeys[i].apiKey,
            apiSecret: "",
            showSecret: false
        } as IShowApiKey)
    }

    return showApiKeys;
}

const getComputed = function () {
    return {
    }
}

const getMethods = function (data: IData, props: any) {
    return {
        updateList: async function () {
            closeModals(data);
            await loadApiKeys(data);
            data.showApiKeys.value = getShowApiKeys(data.apiKeysData.value);
        },
        closeEditApiKeyModal: function (msg?: string) {
            data.showEditApiKeyModal.value = false;
            if (msg) {
                updateMessage(data, msg);
            }
        },
        getSecret: async function (apiKey: ApiKeyModel) {

            if (!data.isLoading.value && apiKey != null) {
                try {

                    const apiKeyService = await context.getService<IApiKeyService>('IApiKeyService');
                    const result = await apiKeyService.getSecret(apiKey.apiKey ?? "");

                    if (result && result.ok) {

                        for (var i = 0; i < data.showApiKeys.value.length; i++) {
                            if (data.showApiKeys.value[i].apiKey == apiKey.apiKey) {

                                data.showApiKeys.value[i].apiSecret = result.data ?? "";
                                if (result.data != "") {
                                    data.showApiKeys.value[i].apiSecret = result.data ?? "";
                                    data.showApiKeys.value[i].showSecret = true;
                                }
                            }
                        }
                    } else {
                        showMessage('An error occured while getting api secret.', "danger", true, true);
                    }
                } catch (err) {
                    console.log("Error getting api secret.")
                    showMessage('An error occured while getting api secret.', "danger", true, true);
                } finally {
                    data.isLoading.value = false;
                }
            }
        },
        showEditModal: function (apiKey: ApiKeyModel) {
            data.editApiKey.value = apiKey;
            data.showEditApiKeyModal.value = true;
        },
        showRemoveModal: function (apiKey: ApiKeyModel) {
            data.removeApiKey.value = apiKey;
            data.showRemoveApiKeyModal.value = true;
        },
        canDisplaySecret: function (apiKey: ApiKeyModel) {
            for (var i = 0; i < data.showApiKeys.value.length; i++) {
                if (data.showApiKeys.value[i].apiKey == apiKey.apiKey &&
                    data.showApiKeys.value[i].apiSecret != "")
                {
                    return true;
                }
            }

            return false;
        },
        displaySecret: function (apiKey: ApiKeyModel) {
            for (var i = 0; i < data.showApiKeys.value.length; i++) {
                if (data.showApiKeys.value[i].apiKey == apiKey.apiKey &&
                    data.showApiKeys.value[i].apiSecret != "") {
                    return data.showApiKeys.value[i].apiSecret;
                }
            }
        },
        refreshApiKeys: async function (apiKey: string, secret: string) {
            for (var i = 0; i < data.showApiKeys.value.length; i++) {
                if (data.showApiKeys.value[i].apiKey == apiKey) {
                    data.showApiKeys.value[i].apiSecret = secret;
                }
            }

            data.refreshApiKey.value = undefined;
            data.showRefreshApiKeyModal.value = false;
        },
        confirmRefreshApiKeyModal: function (apiKey: ApiKeyModel) {
            if (apiKey != null) {
                data.refreshApiKey.value = apiKey;
                data.showRefreshApiKeyModal.value = true;
            }
        },
        closeRefreshApiKey: function () {
            data.refreshApiKey.value = undefined;
            data.showRefreshApiKeyModal.value = false;
        },
        confirmRemoveApiKeyModal: function (apiKey: ApiKeyModel) {
            if (apiKey != null) {
                data.removeApiKey.value = apiKey;
                data.showRemoveApiKeyModal.value = true;
            }
        },
        closeRemoveApiKey: function () {
            data.removeApiKey.value = undefined;
            data.showRemoveApiKeyModal.value = false;
        },
        cancelEditApiKey: function () {
            data.showEditApiKeyModal.value = false;
        },
        cancelAddApiKey: function () {
            data.showAddApiKeyModal.value = false;
        },

        showAddWebhook: function () {
            data.showAddWebhookModal.value = true;
        },
        closeAddWebhookModal: function () {
            data.showAddWebhookModal.value = false;
        },
        addWebhookAddress: function (address: WebhookAddress) {
            if (address) {
                if (!data.webhooksData.value.some((h) => h.address == address.address)) {
                    data.webhooksData.value.push(address);
                } else {
                    const index = data.webhooksData.value.findIndex((h) => h.address == address.address);
                    if (index !== -1) {
                        data.webhooksData.value.splice(index, 1, address);
                    }
                }
                data.showAddWebhookModal.value = false;
            }
        },
        removeWebhook: async function (address: WebhookAddress) {
            data.showRemoveWebhookModal.value = address;
            
        },
        removeWebhookAddress: async function () {
            if (!data.isLoading.value && data.showRemoveWebhookModal.value) {
                try {
                    data.isLoading.value = true;

                    let service = await context.getService<IWebhookService>('IWebhookService');
                    let res = await service.remove(data.showRemoveWebhookModal.value);
                    if (res.ok) {
                        data.webhooksData.value = data.webhooksData.value.filter(w => w != data.showRemoveWebhookModal.value);
                        data.showRemoveWebhookModal.value = undefined;
                    } else {
                        showMessage('There was an error removing your webhook.', "danger", true, true);
                    }
                }
                catch (err) {
                    console.log(err);
                    showMessage('There was an error removing your webhook.', "danger", true, true);
                }
                finally {
                    data.isLoading.value = false;
                }
            }
        },
        closeRemoveWebhookModal: function () {
            data.showRemoveWebhookModal.value = undefined;
        },
        verifyWebhook: function (address: WebhookAddress) {
            data.showVerifyWebhookModal.value = address;
        },
        closeVerifyWebhookModal: function () {
            data.showVerifyWebhookModal.value = undefined;
        },
        verifyWebhookAddress: function (address: WebhookAddress) {
            if (data.showVerifyWebhookModal.value == address) {
                data.showVerifyWebhookModal.value.isVerified = true;
                data.showVerifyWebhookModal.value = undefined;
            }
        },
        showVerificationTokens: async function () {
            try {
                let service = await context.getService<IWebhookService>('IWebhookService');
                let res = await service.getWebhookAuthTokens(context.user?.accountId ?? '');
                data.verificationToken1.value = res.primaryToken;
                data.verificationToken2.value = res.secondaryToken;
            }
            catch (err) {
                showMessage('There was an error retrieving your verification tokens.', "danger", true, true);
                data.verificationToken1.value = undefined;
                data.verificationToken2.value = undefined;
            }
        },
        rotateVerificationTokens: async function () {
            try {
                data.showConfirmRotateModal.value = false;
                let service = await context.getService<IWebhookService>('IWebhookService');
                let res = await service.rotateAuthTokens(context.user?.accountId ?? '');
                data.verificationToken1.value = res.primaryToken;
                data.verificationToken2.value = res.secondaryToken;
            }
            catch (err) {
                showMessage('There was an error rotsting your verification tokens.', "danger", true, true);
            }
        },
        closeConfirmRotateModal: function () {
            data.showConfirmRotateModal.value = false;
        },

        copyValue: async function (valueToCopy: string) {
            await navigator.clipboard.writeText(valueToCopy);
            showMessage('Value copied to clipboard.', "info", true, true);
        },

        createApiToken: async function () {
            if (!data.isLoading.value) {
                try {
                    data.isLoading.value = true;

                    var service = await context.getService<IApiTokenService>('IApiTokenService');
                    var res = await service.createToken();
                    if (res.ok && res.message) {
                        data.apiTokens.value.push(res.message);
                    } else {
                        showMessage('There was an error creating a new API authentication token.  Please contact us for support.', "danger", true, false);
                    }
                }
                catch (err) {
                    console.log(err);
                    showMessage('There was an error creating a new API authentication token.  Please contact us for support.', "danger", true, false);
                }
                finally {
                    data.isLoading.value = false;
                }
            }
        },

        showApiToken: function (token: string) {
            if (data.shownToken.value == token) {
                data.shownToken.value = undefined;
            } else {
                data.shownToken.value = token;
            }
        },

        showRemoveApiToken: function (token: string) {
            data.showRemoveApiTokenModal.value = token;
        },

        closeRemoveApiTokenModal: function () {
            data.showRemoveApiTokenModal.value = undefined;
        },

        removeApiToken: async function () {
            if (!data.isLoading.value && data.showRemoveApiTokenModal.value) {
                try {
                    data.isLoading.value = true;

                    let token = data.showRemoveApiTokenModal.value;
                    var service = await context.getService<IApiTokenService>('IApiTokenService');
                    var res = await service.expireToken(token);
                    if (res.ok) {
                        data.apiTokens.value = data.apiTokens.value.filter(t => t != token);
                        data.showRemoveApiTokenModal.value = undefined;
                    } else {
                        showMessage('There was an error removing your API authentication token.  Please contact us for support.', "danger", true, false);
                    }
                }
                catch (err) {
                    console.log(err);
                    showMessage('There was an error removing your API authentication token.  Please contact us for support.', "danger", true, false);
                }
                finally {
                    data.isLoading.value = false;
                }
            }
        }
    };
}

const updateMessage = function (data: IData, msg: string) {
    data.statusUpdateMessage.value = msg;
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });

    setTimeout(hideStatusMessage.bind(null, data), 5000);
}

const hideStatusMessage = function (data: IData) {
    data.statusUpdateMessage.value = '';
}

const loadApiKeys = async function (data: IData) {
    if (!data.isLoading.value && data.accountId.value) {
        try {
            const apiKeyService = await context.getService<IApiKeyService>('IApiKeyService');
            const result = await apiKeyService.findByAccount(data.accountId.value);

            if (result && result.ok) {
                data.apiKeysData.value = result.data?.filter(a => a.status != ApiKeyStatus.Archived) ?? []
            } else {
                showMessage('An error occured while querying api keys.', "danger", true, true);
            }

        } catch (err) {
            console.log("Error querying api keys.");
            showMessage('An error occured while querying api keys.', "danger", true, true);
        } finally {
            data.isLoading.value = false;
        }
    }
}

const loadApiTokens = async function (data: IData) {
    if (!data.isLoading.value) {
        try {
            data.isLoading.value = true;

            var service = await context.getService<IApiTokenService>('IApiTokenService');
            var res = await service.getTokens();
            if (res.ok && res.data) {
                data.apiTokens.value = res.data;
            } else {
                showMessage('There was an error retrieving your API authentication tokens.  Please contact us for support.', "danger", true, false);
            }
        }
        catch (err) {
            console.log(err);
            showMessage('There was an error retrieving your API authentication tokens.  Please contact us for support.', "danger", true, false);
        }
        finally {
            data.isLoading.value = false;
        }
    }
}

export default defineComponent({
    name: "Integrations",
    props: {
        accountId: String,
        apiKeys: {
            type: Array as () => ApiKeyModel[],
            default: []
        },
        webhooks: {
            type: Array as () => WebhookAddress[],
            default: []
        }
    },
    components: {
        "refresh-api-key": refreshApiKey,
        "remove-api-key": removeApiKey,
        "edit-api-key": editApiKey,
        "add-api-key": addApiKey,
        "add-webhook": addWebhook,
        "verify-webhook": verifyWebhook
    },
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let computed = getComputed();
        let methods = getMethods(data, props);

        watch(() => props.apiKeys, function () {
            data.apiKeysData.value = props.apiKeys;
        });

        watch(() => props.webhooks, function () {
            data.webhooksData.value = props.webhooks;
        });

        onMounted(async () => {
            await loadApiTokens(data);
        })

        return {
            ...data,
            ...computed,
            ...methods,
            WebhookFormat
        }
    }
})

